<template>
  <div class="box">
    <div class="pic">
      <img src="@/assets/image/platform/ipad.png" alt="ipad软件">
    </div>
    <div class="des">
      <h3>{{$t("platform.mt4.title3")}}</h3>
      <p class="info" v-html="describe"></p>
      <button class="btn btn-primary"  @click="$open('android')">{{$t("platform.mt4.download5")}}</button>
      <button class="btn btn-primary ml20"  @click="$open('iOS')">{{$t("platform.mt4.download6")}}</button>
    </div>
  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  computed: {
    describe() {
      return this.$t("platform.mt4.describe3")
    }
  }
}
</script>
<style scoped lang="scss">
  .ml20{
    margin-left: 20px;
  }
.box{
  display: flex;
  padding: 120px 0;
  .pic, .des{
    flex: 1;
  }
  .pic{
    text-align: right;
    padding-right: 36px;
    img{
      // border: 1px dashed #000;
      display: inline-block;
    }
  }
  .des{
    padding-left: 36px;
    h3{
      height: 50px;
      font-size: 36px;
      font-weight: bold;
      color: #000000;
      line-height: 50px;
      margin-top: -30px;
    }
    .info{
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      color: rgba($color: #000000, $alpha: 0.6);
      line-height: 28px;
    }
    button{
      margin-top: 30px;
    }
  }
}
</style>